import React from 'react';
import { LazyRender } from '@noths/polaris-client-ribbons-design-system';
import { ProductCarousel } from '@noths/polaris-design-system-candidate-components';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import {
  getSeeAllLinkText,
  PlpPreviewProducts,
} from 'src/components/organisms/PlpPreviewProducts/PlpPreviewProducts';
import * as styles from './PlpPreviewSection.style';

export interface PlpPreviewSectionProps {
  currency: CurrencyCode;
  heading: string;
  /** The page's own pageType, the `<location>` half of the tracked list value. */
  pageType: string;
  plpUrl: string;
  trackingPosition: number;
  trackingTitle: string;
}

export const PlpPreviewSection = ({
  currency,
  heading,
  pageType,
  plpUrl,
  trackingPosition,
  trackingTitle,
}: PlpPreviewSectionProps) => {
  return (
    <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.wrapper}>
      {/* The placeholder is the carousel's own loading state, so the PLP heading
          and link are in the initial HTML for crawlers and nothing about the block
          changes shape when the real one mounts. The endpoint fetch only starts
          once the block scrolls near the viewport and PlpPreviewProducts mounts. */}
      <LazyRender
        options={{ rootMargin: '200px' }}
        placeholder={
          <ProductCarousel
            heading={heading}
            products={null}
            subheadingLink={{ href: plpUrl, text: getSeeAllLinkText(heading) }}
          />
        }
      >
        <PlpPreviewProducts
          currency={currency}
          heading={heading}
          pageType={pageType}
          plpUrl={plpUrl}
          trackingPosition={trackingPosition}
          trackingTitle={trackingTitle}
        />
      </LazyRender>
    </SectionContainer>
  );
};
